import React, { useEffect, useState } from "react";
import "./CommitmentSection.css";

export default function CommitmentSection() {
  const [commitment, setCommitment] = useState({
    title: "",
    percent: "",
    description: "",
    donation_value: "",
    donation_label: "",
    image: ""
  });

  /* ===============================
     FETCH COMMITMENT DATA
  ================================ */
  useEffect(() => {
    fetch("https://pharma.accendiatechnologies.com/batterjee/getvideos.php")
      .then(res => res.json())
      .then(data => {
        if (data.status === "success" && data.commitment) {
          setCommitment({
            title: data.commitment.title || "",
            percent: data.commitment.percent || "",
            description: data.commitment.description || "",
            donation_value: data.commitment.donation_value || "",
            donation_label: data.commitment.donation_label || "",
            image: data.commitment.image || ""
          });
        }
      })
      .catch(() => {});
  }, []);

  /* ===============================
     PARSE VALUES (66%, $2 M, etc.)
  ================================ */
  const percentMatch = commitment.percent.match(/(\d+)%/) || [];
  const percentValue = percentMatch[1] || commitment.percent;

  const donationMatch =
    commitment.donation_value.match(/([€£$]?)(\d+)\s*(M|B)?/i) || [];
  const donationCurrency = donationMatch[1] || "";
  const donationAmount = donationMatch[2] || "";
  const donationSuffix = donationMatch[3] || "";

  return (
    <section className="commitment-section">
      <div className="commitment-inner">

        {/* LEFT */}
        <div className="commitment-left">
          <h2
            className="commitment-title"
            dangerouslySetInnerHTML={{ __html: commitment.title }}
          />

          <div className="metric-row">
            <span className="metric-big">{percentValue}%</span>
            <span
              className="metric-text"
              dangerouslySetInnerHTML={{ __html: commitment.description }}
            />
          </div>
        </div>

        {/* RIGHT */}
        <div className="commitment-right">
          <div className="donation-row">
            <span className="green">{donationCurrency}{donationAmount}</span>
            <span className="purple">{donationSuffix}</span>
            <span className="donation-text">{commitment.donation_label}</span>
          </div>

          <div className="commitment-image">
            {commitment.image && (
              <img src={commitment.image} alt="Sustainability" />
            )}
          </div>
        </div>

      </div>
    </section>
  );
}
